import { View } from "react-native";

import type { ConfigError } from "@/config";
import { Text } from "@/ui/Text";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

/**
 * Shown instead of the app when the embedded public config is missing or malformed, naming the
 * setting (FR-037; research R14). The config holds public values only, so it is safe to show.
 */
export function ConfigErrorScreen({ error }: { error: ConfigError }) {
  const styles = useScreenStyles();
  return (
    <View style={styles.screen} testID="config-error-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <Text variant="heading" accessibilityRole="header" aria-level={1}>
          The app is not configured correctly
        </Text>
        <Text tone="muted" style={styles.message}>
          {error.message}
        </Text>
        <Text tone="muted" size="sm" style={styles.message}>
          Setting: {error.setting}
        </Text>
      </View>
    </View>
  );
}
